import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4 pb-5 bg-primary text-on-primary" }
const _hoisted_2 = { class: "text-16px" }

import { useMainStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const mainStore = useMainStore()

return (_ctx: any,_cache: any) => {
  const _component_c_btn = _resolveComponent("c-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(_unref(mainStore).environment.customerName), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(mainStore).environment.name), 1),
    (_unref(mainStore).environment.count > 1)
      ? (_openBlock(), _createBlock(_component_c_btn, {
          key: 0,
          href: "#",
          color: "white",
          class: "w-full mt-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('change_environment')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})